import { type IAssignableExpression } from '@framework/engine/schema/expressions/repository/assignable/IAssignableExpression.ts';
import { type IConditionGroupExpression } from '@framework/engine/schema/expressions/repository/condition-group/IConditionGroupExpression.ts';
import { type IBaseWidget } from '@framework/engine/schema/widgets/IBaseWidget.ts';
import { type IInputWidget } from '@framework/engine/schema/widgets/repository/inputs/IInputWidget.ts';
import { type WidgetType } from '@framework/engine/schema/widgets/Widget.ts';

// L'augmentation vive accanto all'interfaccia che la usa (e non nel
// `*.type.tsx`) così che `WidgetType.ModuleTrigger` sia disponibile in
// qualsiasi package che importi questo file, senza dover trascinare il
// file del widget.
declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    ModuleTrigger = 'moduleManager',
  }
}

export interface IModuleTriggerWidget extends IInputWidget {
  type: WidgetType.ModuleTrigger;

  /**
   * Identificativo modulo da attivare
   */
  moduleId?: string | null;

  /**
   * Condizione di attivazione
   */
  expression: IConditionGroupExpression;

  needUniqueModuleCode: boolean;

  /**
   * Codice univoco di attivazione. Se più attivatori utilizzano lo stesso
   * codice univoco, verrà attivato un unico modulo.
   */
  uniqueModuleCode: IAssignableExpression | null | undefined;

  /**
   * Titolo da fornire al modulo per permettere all'utente di identificarlo.
   */
  title: IAssignableExpression | null | undefined;
}

export const WidgetModuleTriggerType =
  'moduleTrigger' as WidgetType.ModuleTrigger;

export function isModuleTriggerWidget(
  w: IBaseWidget,
): w is IModuleTriggerWidget {
  return w.type === WidgetModuleTriggerType;
}
